'use client';

import type {
  MouseEvent as ReactMouseEvent,
  PointerEvent as ReactPointerEvent,
  Ref,
} from 'react';
import { MessageAdd01Icon } from '@terra/ui-icons';
import { IconButton, Tooltip } from '@terra/ui-design-system';

type SendToChatIconButtonProps = {
  label: string;
  onClick: () => void;
  disabled?: boolean;
  variant?: 'ghost' | 'outline';
  iconSize?: number;
  buttonRef?: Ref<HTMLButtonElement>;
  onPointerDown?: (event: ReactPointerEvent<HTMLButtonElement>) => void;
  onMouseDown?: (event: ReactMouseEvent<HTMLButtonElement>) => void;
};

export function SendToChatIconButton({
  label,
  onClick,
  disabled,
  variant = 'ghost',
  iconSize = 12,
  buttonRef,
  onPointerDown,
  onMouseDown,
}: SendToChatIconButtonProps) {
  return (
    <Tooltip title={label}>
      <IconButton
        ref={buttonRef}
        size="xs"
        variant={variant}
        aria-label={label}
        disabled={disabled}
        onClick={onClick}
        onPointerDown={onPointerDown}
        onMouseDown={onMouseDown}
      >
        <MessageAdd01Icon size={iconSize} />
      </IconButton>
    </Tooltip>
  );
}
